export enum ApiUrl {
  /**Estimate */
  ESTIMATE = '/estimate',
  /**
   * @deprecated temporary endpoint - will use just ESTIMATE after the API change is validated
   */
  ESTIMATE_MULTIPART = '/estimate/new',
  ESTIMATE_CODE = '/estimate/code',
  ESTIMATE_NUMBER = '/estimate/number',
  ESTIMATE_STATUS = '/estimate/status',
  ESTIMATE_PDF = '/estimate/pdf',

  /**Laminate */
  LAMINATE_CAPS = '/laminate/caps',
  LAMINATE_SPLASHES = '/laminate/splashes',

  /**Products */
  CORNER_RADII = '/products/radii',
  CUSTOMER_SUPPLIED_SINKS = '/products/customer-supplied-sinks',
  CUSTOMER_SUPPLIED_COOKING_APPLIANCES = './public/mock/predefined-cooking-appliances.json',
  CUTOUT_LABOR = '/products/cutout-labor',
  DIAGONAL_CORNERS = '/products/diagonal-corners',
  EDGES = '/products/edges',
  MATERIALS = '/products/materials',
  OPTIONAL_ITEMS = '/products/optional-items',
  PLUMBING = '/products/plumbing',
  PRICES = '/products/prices',
  SHAPE_DRAWING = '/products/shape-drawing',
  SINK_LABOR = '/products/sink-labor',
  SINKS = '/products/sinks',
  SWATCHES = '/products/swatches',
  WATERFALL_LABOR = '/products/waterfall-labor',

  /**Retailer */
  RETAILER_SETTINGS = '/retailer/settings',

  /**Shapes */
  PREDEFINED_SHAPES = './public/assets/predefined-shapes.json',

  /**Stores */
  STORES = '/stores',

  TICKETS = '/estimate/tickets',
  ZIPCODE_LOCATION = '/zip-code/city',

  MILEAGE_TIERS_URL = '/products/mileage',
  CFIS_URL = '/retailer/cfis',
  LOOKUP_RETAILER = '/lookup/retailer',
}
